import React from "react";
import ReactMarkdown from "react-markdown";

export const BodyRenderer = ({ body, post }) => {
  if (!body || !Array.isArray(body)) return null;

  return (
    <>
      {body.map((block, idx) => {
        switch (block.type) {
          case "image_text":
            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: "1rem",
                  marginBottom: "2rem",
                  alignItems: "center",
                }}
              >
                <img
                  src={block.image}
                  alt={block.alt || post?.title || ""}
                  style={{
                    maxWidth: "200px",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
                <div style={{ flex: 1 }}>
                  <ReactMarkdown>{block.text || ""}</ReactMarkdown>
                </div>
              </div>
            );

          case "text_only":
            return (
              <div key={idx} style={{ marginBottom: "1.5rem" }}>
                <ReactMarkdown>{block.text || ""}</ReactMarkdown>
              </div>
            );

          case "image_only":
            return (
              <div key={idx} style={{ marginBottom: "1.5rem" }}>
                <img
                  src={block.image}
                  alt=""
                  style={{ maxWidth: "100%", borderRadius: "8px" }}
                />
              </div>
            );

          default:
            return null;
        }
      })}
    </>
  );
};

export const MarkdownRenderer = ({ post }) => {
  if (!post) return null;

  return (
    <article style={{ maxWidth: "700px", margin: "auto", padding: "1rem" }}>
      <h1>{post.title}</h1>
      {post.date && (
        <time
          dateTime={post.date}
          style={{ color: "#666", fontSize: "0.9rem" }}
        >
          {new Date(post.date).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </time>
      )}
      {post.image && (
        <img
          src={post.image}
          alt=""
          style={{
            width: "100%",
            maxHeight: "400px",
            objectFit: "cover",
            borderRadius: "8px",
            marginTop: "1rem",
            marginBottom: "2rem",
          }}
        />
      )}
      <BodyRenderer body={post.body} post={post} />
    </article>
  );
};
export default MarkdownRenderer;